/** Returns JWT `exp` in milliseconds since Unix epoch, or null if absent or unparseable. */
export const getJwtExpMs = (token: string): null | number => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );

    const { exp } = JSON.parse(jsonPayload) as { exp?: number };
    if (typeof exp !== 'number') return null;
    return exp * 1000;
  } catch {
    return null;
  }
};
